import React from 'react';

class StaticContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({ hover: true });
  }

  onMouseLeave() {
    this.setState({ hover: false });
  }

  render() {
    return (
      <li onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <a
          href="javascript:;"
          onClick={this.props.onStaticTextClick.bind(null, this.props.cid)}
        >
          {this.props.name}
        </a>
        &nbsp;
        {this.state.hover ? (
          <a
            href="javascript:;"
            onClick={this.props.onEdit.bind(
              null,
              this.props.cid,
              this.props.name,
            )}
          >
            <span className="fa fa-pencil text-primary" />
          </a>
        ) : null}
      </li>
    );
  }
}

export default StaticContent;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/StaticContent.jsx